import { type ReactElement, useContext } from 'react';
import Head from 'next/head';
import { ErrorPage } from '@zg-rentals/error-page-components';
import { ERROR_DETAILS, ERROR_MESSAGE } from '@zg-rentals/satellite-components';
import Layout from '../components/Layout';
import StringConstants from '../constants/StringConstants';
import brandUtils from '../utils/brandUtils';
import HotpadsErrorPage from '../components/HotpadsErrorPage';
import { AppContext } from '../contexts/AppContextProvider';

export default function Custom500({ brand: brandProp, paths: pathsProp }: { brand?: Brand; paths?: Record<any, any> }) {
  // Try to get brand and paths from context, fallback to props (for when called from _app.tsx)
  const context = useContext(AppContext);
  const brand = brandProp || context?.brand;
  const paths = pathsProp || context?.paths;

  const isHotpadsBrand = brand ? brandUtils.isHotpads(brand) : false;
  const isDevelopment = process.env.NODE_ENV === 'development';
  const returnToDevToolsText = 'Return to SRW Dev Tools Page';

  if (isHotpadsBrand) {
    return (
      <HotpadsErrorPage
        errorCode={500}
        ctaText={isDevelopment ? returnToDevToolsText : 'Return to HotPads'}
        ctaUrl={isDevelopment ? paths?.devToolsPage : '/'}
      />
    );
  }

  const ctaText = isDevelopment ? returnToDevToolsText : 'Return to Zillow Renter Hub';
  const ctaUrl = isDevelopment ? paths?.devToolsPage : paths?.renting;

  return (
    <ErrorPage
      errorMessage={ERROR_MESSAGE}
      errorDetails={ERROR_DETAILS}
      action={ctaUrl ? <a href={ctaUrl}>{ctaText}</a> : undefined}
    />
  );
}

Custom500.getLayout = function getLayout(page: ReactElement) {
  return (
    <Layout>
      <>
        <Head>
          <title>{StringConstants.ERROR_PAGE_TITLE}</title>
        </Head>
        {page}
      </>
    </Layout>
  );
};
